<template>
  <div>
    <el-form class="toolbar" :inline="true" :model="query" @keyup.enter.native="pageIndex = 1; load()">
      <el-form-item label="主物料">
        <el-select v-model="query.materialId" placeholder="请选择主物料" size="small" filterable clearable style="width: 280px;">
          <el-option v-for="item in materials" :key="item.materialId" :label="item.materialCode + ' / ' + item.materialName" :value="item.materialId" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('base:materialAttribute:list')" type="primary" size="small" @click="pageIndex = 1; load()">查询</el-button>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button v-if="isAuth('base:materialAttribute:save')" type="primary" size="small" @click="open()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" style="width:100%" :header-cell-style="headStyle">
      <el-table-column type="index" label="序号" header-align="center" align="center" width="60" />
      <el-table-column prop="materialCode" label="主物料编码" header-align="center" align="left" width="130" />
      <el-table-column prop="materialName" label="主物料名称" header-align="center" align="left" width="150" show-overflow-tooltip />
      <el-table-column prop="attributeName" label="属性名称" header-align="center" align="left" width="140">
        <template slot-scope="scope">
          <span v-if="isAuth('base:materialAttribute:info')" class="code-link" @click="open(scope.row, true)">{{ scope.row.attributeName }}</span>
          <span v-else>{{ scope.row.attributeName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="attributeValue" label="默认属性值" header-align="center" align="left" width="160" />
      <el-table-column prop="valueList" label="属性值集合" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope">{{ (scope.row.valueList || []).map(i => i.attributeValue).join('，') }}</template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" header-align="center" align="center" width="80" />
    </el-table>
    <el-pagination class="list-pagination" @size-change="val => { pageSize = val; pageIndex = 1; load() }"
      @current-change="val => { pageIndex = val; load() }" :current-page="pageIndex" :page-sizes="[20, 50, 100]"
      :page-size="pageSize" :total="total" layout="total, sizes, prev, pager, next, jumper" />
    <material-attribute-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialAttributeAddOrUpdate from './materialAttribute-add-or-update'

export default {
  name: 'MaterialAttribute',
  components: { MaterialAttributeAddOrUpdate },
  data() {
    return {
      query: { materialId: '' }, materials: [], list: [], pageIndex: 1, pageSize: 20, total: 0, loading: false,
      addOrUpdateVisible: false, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    this.loadMaterials()
  },
  activated() {
    this.loadMaterials()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadMaterials() {
      request.post('/base/material/page', { currentPage: 1, pageSize: 500 }).then(res => {
        this.materials = (res.data && res.data.list) || []
      }).catch(() => {})
    },
    load() {
      if (!this.query.materialId) {
        this.list = []
        this.total = 0
        this.$message.warning('请先选择主物料')
        return
      }
      this.loading = true
      request.post('/base/materialAttribute/list', {
        currentPage: this.pageIndex, pageSize: this.pageSize, materialId: this.query.materialId
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).catch(() => { this.list = []; this.total = 0 }).finally(() => { this.loading = false })
    },
    open(row, readonly) {
      if (!row && !this.query.materialId) {
        this.$message.warning('请先选择主物料')
        return
      }
      this.addOrUpdateVisible = true
      this.$nextTick(() => { this.$refs.addOrUpdate.init(row, readonly, this.query.materialId) })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 10px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
.code-link:hover { text-decoration: underline; }
</style>
